import { autoinject, observable } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import * as moment from 'moment';
import { CarrierDocument } from '../../models/carrier-document';
import { BusyService } from '../../services/busy-service';

@autoinject
export class UploadDocumentDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService) {
        this.api.containerId = "upload-document-dialog";
    }

    carrierGuid: string;
    carrierId: number;
    carrierName: string;
    filesElement: any;
    selectedFiles = [];
    document: CarrierDocument;
    form: any;
    @observable
    documentTypes = [];
    documentTypesChanged() {
        this.buildDocumentDefaultTitle();
    }

    documentVersionId: string;
    @observable
    documentType: string = "";
    documentArchive: boolean;
    @observable
    documentTypeId: number = 0;
    documentTypeIdChanged() {
        this.buildDocumentDefaultTitle();
    }

    buildDocumentDefaultTitle() {
        var docType = this.documentTypes.find(item => item.id == this.documentTypeId);
        var title = "";
        if (docType) {
            title = docType.description.trim();
        } else {
            title = "";
        }
        this.documentDefaultTitle = title || this.documentTitle || "";

        //if adding new version, then add counter to end of document
        if (this.mode == "new_version") {
            this.documentDefaultTitle = this.documentDefaultTitle + " #" + (this.versionCount + 1);
        }
    }

    mode: string;
    documentId: string;
    documentTitle: string;
    documentTypeIds: string[];
    documentDefaultTitle: string;
    carrierDocuments: Array<CarrierDocument> = [];
    versionCount: number;

    async activate(params) {

        this.document = params.document;
        this.carrierGuid = params.carrierGuid;
        this.carrierId = params.carrierId;
        this.carrierName = params.carrierName;
        this.documentTypeIds = params.documentTypeIds || [];
        this.documentArchive = !!params.documentArchive;

        this.buildDocumentDefaultTitle();

        if (this.document) {
            this.mode = "new_version";
            this.versionCount = params.versionCount;
            this.documentId = this.document.documentId;
            this.documentTypeId = this.document.documentTypeId;
            this.documentTitle = this.document.documentType.trim() + " #" + (params.versionCount + 1);
        } else {

            this.mode = "initial";

            //this is so that we can limit the available doc types based on the documents that have been added so far.
            //only needed when adding a new document
            await this.loadCarrierDocuments(this.carrierGuid);
            await this.loadDocumentTypes();

            if (this.documentTypes.length == 1) {
                this.documentTypeId = this.documentTypes[0].id;
            }
        }
    }
    

    async loadDocumentTypes() {
        this.busyService.on();
        return this.api.get("Carriers", "GetDocumentTypes")
            .then((result) => {
                let allDocumentTypes = JSON.parse(result.response);
                this.documentTypes = allDocumentTypes.filter(docType => {
                    // only allow specified types, if specified
                    if (this.documentTypeIds.length > 0) {
                        if (this.documentTypeIds.indexOf(docType.documentTypeId) == -1) {
                            return false;
                        }
                        return true;
                    }

                    //only allow upload of type "Other" or types that haven't already been uploaded
                    if (docType.code == "O") {
                        return true;
                    } else {
                        return !this.carrierDocuments.find(cdt => cdt.documentTypeId == docType.id);
                    }
                });
            })
            .finally(() => this.busyService.off());
    }

    async loadCarrierDocuments(carrierGuid: string) {
        return this.api.get("Carriers", "GetCarrierDocuments", { carrierGuid: carrierGuid })
            .then((result) => {
                this.carrierDocuments = JSON.parse(result.response);
            });
    }


    doUpload() {
        return this.upload('api/upload', this.selectedFiles)
            .then((result) => {
                let resultObj = JSON.parse(result.response);
                this.controller.ok(resultObj);
            });
    }

    clearFiles() {
        this.filesElement.value = "";
    }

    upload(url, files) {

        if (!this.documentTypeId) {
            alert("Please select document type");
            return Promise.resolve();
        }
        if (this.documentTypeId == 11 && !this.documentTitle) {
            alert("When Other is selected, the document title must be specified.");
            return Promise.resolve();
        }

        // //if the document record already exists, then a subsequent update is to upload a file.
        // //if not, then the initial insert can optionally include the file to upload.
        // if (this.documentId && files.length == 0) {
        //     alert("Please choose a file to upload.");
        //     return Promise.resolve();
        // }

        // since introduction of onboarding requirements matrix, documents cannot be created without a file uploaded
        if (files.length == 0) {
            alert("Please choose a file to upload.");
            return Promise.resolve();
        }

        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
        }
        //formData.append('DocumentId', this.carrierDocumentTypeXrefId.toString());
        formData.append('CarrierGuid', this.carrierGuid);
        formData.append('DocumentId', this.documentId);
        formData.append('DocumentTypeId', this.documentTypeId.toString());
        formData.append('DocumentArchive', this.documentArchive.toString());
        formData.append('Title', this.documentTitle || this.documentDefaultTitle);

        this.busyService.on();
        return this.api.post("document", "upload", formData)
            .finally(() => {
                this.busyService.off();
            });
    }

    submit() {
        this.form.submit();
    }


}